export const getQuantityWithinStock = (quantity: number, stockValue?: number) => {
  if (stockValue === 0) {
    return 0;
  }

  return !!stockValue && quantity > stockValue ? stockValue : quantity;
};
